import { Component,  OnDestroy, OnInit, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CommonService } from './core/services/common/common.service';
import { Subscription } from 'rxjs';
import { HttpService } from './core/services/http/http.service';
import { RouterService } from './core/services/router/router.service';

@Injectable({
  providedIn: 'root'  // <-- ensures Angular can inject it anywhere
})

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'GROWMIS';
  currentUrl: any;
  userMode: any;
  paramSubscription!: Subscription;
  routeSubscription!: Subscription;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly _common: CommonService,
    private readonly httpService: HttpService,
    // Injected purely to force RouterService to be instantiated at app
    // bootstrap. Its constructor subscribes to NavigationEnd events and
    // tracks the previous non-error URL for the access-denied page's
    // "Back to previous" button. Without this eager injection it would
    // be created lazily (when AccessDeniedComponent first injects it),
    // missing the earlier NavigationEnd for the page the user was on
    // before they hit the bad URL — so "Back" would always fall through
    // to the default landing page.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private readonly _routerService: RouterService,
  ) { }


  ngOnInit(): void {    
    this.paramSubscription = this.route.params.subscribe(params => {
      this.userMode = params['usermode'];
    });

    this.routeSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) 
        this.currentUrl = event.url;
    });

    this.httpService.getPublicKey().subscribe({
      next: () => console.log('Public key loaded'),
      error: (err) => console.error('Failed to load public key', err)
    });
  }

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }

  handleRouteChange(url: string): void {
    const prefix = url.split('/')?.[1];
    this._common.getSetRouteValue(url);
    const newUrl = url.replace(prefix, this._common.routePrefix);
    if (prefix !== this._common.routePrefix) {
      this.router.navigate([newUrl]);
    }

  }

}
